export const LOCAL_BASE_URL = 'http://localhost:3000/'
export const DEV_BASE_URL = 'https://bo-fe.dev.transporter.brqapps.com/'
export const QA_BASE_URL = 'https://bo-fe.qld.transporter.brqapps.com/'
export const PROD_BASE_URL = 'https://bo-fe.transporter.brqapps.com/'
